import React, {createContext, useContext} from "react";
import {useTravianServerContext} from "../../react/providers/travianServerProvider";
import TravianVersion from "../enum/version";
import {fillPartialFeaturesWithDefaults} from "../Helper/TravianVersionHandling";
import {TravianVersionWithFeatures, TravianVersionWithPartialFeatures} from "../Version";

const TravianConfigContext = createContext<TravianVersionWithFeatures>(null);

export function useTravianConfigContext() {
    return useContext(TravianConfigContext);
}

export function TravianConfigProvider({ children }) {
    const { serverInfo } = useTravianServerContext();

    const partialConfig: TravianVersionWithPartialFeatures = {
        version: serverInfo.tmajor === 4 ? TravianVersion.Legends : TravianVersion.Kingdoms,
        features: {
            speed: serverInfo.speed,
            troopSpeed: serverInfo.speed === 2 ? 2 : (Math.floor(serverInfo.speed / 3) + 1),
        }
    }
    const config = fillPartialFeaturesWithDefaults(partialConfig);

    return <TravianConfigContext.Provider value={config}>
        {children}
    </TravianConfigContext.Provider>
}
